import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

const fetcher = (url) => api.get(url).then((r) => r.data);

export function useSettingsQuery() {
  return useQuery({
    queryKey: ["settings"],
    queryFn: () => fetcher("/settings"),
    staleTime: 20_000,
    refetchOnWindowFocus: true,
  });
}

export function useCollectionsQuery() {
  return useQuery({
    queryKey: ["collections"],
    queryFn: () => fetcher("/collections"),
    staleTime: 20_000,
    refetchOnWindowFocus: true,
  });
}

export function useTestimonialsQuery() {
  return useQuery({
    queryKey: ["testimonials"],
    queryFn: () => fetcher("/testimonials"),
    staleTime: 60_000,
  });
}

export function useFAQsQuery() {
  return useQuery({
    queryKey: ["faqs"],
    queryFn: () => fetcher("/faqs"),
    staleTime: 60_000,
  });
}

export function useGalleryQuery() {
  return useQuery({
    queryKey: ["gallery"],
    queryFn: () => fetcher("/gallery"),
    staleTime: 60_000,
  });
}

export function usePillarsQuery() {
  return useQuery({
    queryKey: ["pillars"],
    queryFn: () => fetcher("/pillars"),
    staleTime: 60_000,
  });
}

export function useStepsQuery() {
  return useQuery({
    queryKey: ["steps"],
    queryFn: () => fetcher("/steps"),
    staleTime: 60_000,
  });
}

export function useTradeFairQuery() {
  return useQuery({
    queryKey: ["tradefair"],
    queryFn: () => fetcher("/tradefair"),
    staleTime: 5 * 60_000,
  });
}

export function useAdminMeQuery(enabled = true) {
  return useQuery({
    queryKey: ["admin-me"],
    queryFn: () => fetcher("/auth/me"),
    enabled,
    retry: false,
    staleTime: 30_000,
  });
}
